var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 88,
    height: 88,
    rx: 44,
    fill: "#E9F5F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 88,
    height: 88,
    rx: 44,
    stroke: "white",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.3333 48.0003C31.3333 41.7149 31.3333 38.5722 33.2859 36.6196C35.2385 34.667 38.3812 34.667 44.6666 34.667H51.3332C57.6186 34.667 60.7614 34.667 62.7139 36.6196C64.6666 38.5722 64.6666 41.7149 64.6666 48.0003C64.6666 54.2857 64.6666 57.4285 62.7139 59.381C60.7614 61.3337 57.6186 61.3337 51.3332 61.3337H44.6666C38.3812 61.3337 35.2385 61.3337 33.2859 59.381C31.3333 57.4285 31.3333 54.2857 31.3333 48.0003Z",
    stroke: "#1C274C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9999 44.667V51.3337M45.1126 46.3337L50.8861 49.667M50.8856 46.3337L45.1121 49.667",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2205 44.667V51.3337M36.3331 46.3337L42.1066 49.667M42.1063 46.3337L36.3328 49.667",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7799 44.667V51.3337M53.8924 46.3337L59.6659 49.667M59.6656 46.3337L53.8921 49.667",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpIcon);
export default __webpack_public_path__ + "static/media/otp_icon.704d47beedefb52c22d9c3ac921933b2.svg";
export { ForwardRef as ReactComponent };